import { render, staticRenderFns } from "./DashcamPromoModal.vue?vue&type=template&id=0f136582&scoped=true"
import script from "./DashcamPromoModal.vue?vue&type=script&setup=true&lang=js"
export * from "./DashcamPromoModal.vue?vue&type=script&setup=true&lang=js"
import style0 from "./DashcamPromoModal.vue?vue&type=style&index=0&id=0f136582&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f136582",
  null
  
)

export default component.exports